import Menu from '../Menu';
import TopMenu from '../TopMenu';
import { useSelector } from 'react-redux';
import { isEmptyData } from '../../../../utils/helper';
import Empty from '../../Empty';
import Tags from '../Tags';
import useGpsGuard from '../../../../hook/useGpsGuard';
import Gps from '../../Gps';
import useProduct from '../../../hook/useProduct';
import { useMemo } from 'react';

const ListProduct = () => {
	const gpsGuard = useGpsGuard();
	const { cart } = useSelector((store) => store?.cart);
	const { keyword, products } = useProduct();

	const filteredProduct = useMemo(() => {
		if (!products?.length) return [];

		let result = [];

		if (!isEmptyData(keyword)) {
			const lowerKeyword = keyword.toLowerCase();
			result = products.filter((product) => product?.product_name?.toLowerCase().includes(lowerKeyword));
		}

		return result;
	}, [products, keyword]);

	return (
		<>
			<div className={`${cart?.totalItem > 0 && 'pb-14'}`}>
				{!isEmptyData(keyword) ? (
					<>
						{!isEmptyData(filteredProduct) ? (
							<>
								<Menu {...{ gps: gpsGuard }} />
							</>
						) : (
							<>
								<Empty />
							</>
						)}
					</>
				) : (
					<>
						<Tags />
						<TopMenu {...{ gps: gpsGuard }} />
						<Menu {...{ gps: gpsGuard }} />
					</>
				)}
			</div>
			<Gps {...gpsGuard} />
		</>
	);
};

export default ListProduct;
